'use strict';

class EmployeesController {
    /* @ngInject */
    constructor(EmployeesService, $scope, $q) {
        Object.assign(this, {EmployeesService, $scope, $q});

        this.query = {
            where: {},
            limit: 25,
            page: 1,
            include: ['segaUser']
        };

        this.getEmployees();
        this.onPagination = () => {
            this.getEmployees();
        };
    }

    getEmployees() {
        let qOpts = Object.assign({}, this.query);

        let queryReady = this.EmployeesService
            .getEmployees(qOpts)
            .then(employees => {
                this.employees = employees;
            });
        let countReady = this.EmployeesService
            .getCount(qOpts)
            .then(result => {
                this.employeesCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }
    
}

export default EmployeesController;
